import { NormalTextInputField } from "@/components";

const HomeMediaSectionFormField = ({
  isFetching,
  stateDetails,
  handleTextInputChange,
}) => {
  return (
    <>
      {/* Heading */}
      <NormalTextInputField
        isFetching={isFetching}
        labelText="Heading"
        fieldId="home-section-10-media-heading"
        fieldName="home-section-10-media-heading"
        placeholderText="Heading"
        inputValue={stateDetails?.["home-section-10-media-heading"] || ""}
        onChangeTextInputField={handleTextInputChange}
        translateField={true}
      />
    </>
  );
};

export default HomeMediaSectionFormField;
